import { motion } from 'framer-motion';
import { Network, Package, Cpu, Building2, CheckCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const services = [
  { icon: Network, title: "Réseaux & Télécom", description: "Audit, câblage structuré, Wi-Fi Corporate et sécurisation d'infrastructures.", features: ["Câblage Cat6/Fibre", "Wi-Fi Haute Densité", "Sécurité Firewall"], color: "#3f782b", path: "/reseaux" },
  { icon: Package, title: "Fournitures de Bureau", description: "Équipements informatiques, mobilier ergonomique et consommables pour professionnels.", features: ["Mobilier Premium", "Matériel Informatique", "Consommables"], color: "#165883", path: "/boutique" },
  { icon: Cpu, title: "Maintenance IT", description: "Contrats de maintenance préventive et curative pour garantir votre continuité d'activité.", features: ["Support 6j/7", "Infogérance", "Backup Cloud"], color: "#3f782b", path: "/services" },
  { icon: Building2, title: "Aménagement", description: "Solutions complètes pour l'aménagement de vos locaux techniques et espaces de travail.", features: ["Salles Serveurs", "Baies 19\"", "Onduleurs/UPS"], color: "#165883", path: "/contact" }
];

const Services = () => {
  return (
    <section className="py-16 sm:py-24 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            viewport={{ once: true, amount: 0.1 }}
            style={{ willChange: 'transform, opacity' }}
          >
            <h2 className="text-3xl sm:text-4xl font-bold mb-4" style={{ color: 'var(--text-primary)' }}>Nos Solutions 360°</h2>
            <p className="max-w-2xl mx-auto" style={{ color: 'var(--text-secondary)' }}>
              Nous accompagnons les entreprises sénégalaises avec des services technologiques de pointe et du matériel de haute qualité.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ delay: i * 0.1 }}
              style={{ willChange: 'transform, opacity' }}
              className="p-8 rounded-3xl theme-card group flex flex-col h-full"
            >
              <Link to={s.path} className="flex flex-col h-full">
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 transition-transform group-hover:scale-110" style={{ background: `${s.color}15` }}>
                  <s.icon size={28} style={{ color: s.color }} />
                </div>
                <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>{s.title}</h3>
                <p className="text-sm leading-relaxed mb-6" style={{ color: 'var(--text-secondary)' }}>{s.description}</p>
                <ul className="space-y-2 mb-8">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-xs font-medium" style={{ color: 'var(--text-secondary)' }}>
                      <CheckCircle size={12} style={{ color: s.color }} /> {f}
                    </li>
                  ))}
                </ul>
                <div className="mt-auto flex items-center gap-2 text-sm font-bold transition-all group-hover:gap-3" style={{ color: s.color }}>
                  Découvrir <ArrowRight size={16} />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
